module.exports = __webpack_public_path__ + "static/media/patch.fa874b5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/PP/assets/patch.jpg
// module id = 209
// module chunks = 0